<template>
    <div class="main__layout">
         <transition name="zoom-fade" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" />
         </transition>
    </div>
</template>

<script>
import '@/assets/css/transitions.css';

export default {
    data() {
        return {
            routeTitle        : this.$route.meta.pageTitle,
        }
    },
     watch: {
         '$route' () {
            this.routeTitle = this.$route.meta.pageTitle
        },
     },
     methods: {
         changeRouteTitle (title) {
            this.routeTitle = title
        }
     }
}
</script>

<style>

</style>